module.exports = __webpack_public_path__ + "static/media/frozen7.cf06272f.png";